var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\tOverview\n\n\t"),_c('router-link',{attrs:{"to":"ibd-follow-up"}},[_vm._v("test")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }